__turbopack_context__.v({
  "contactUsForm": "ContactUsForm-module-scss-module__P1OLdq__contactUsForm",
  "contactUsFormInner": "ContactUsForm-module-scss-module__P1OLdq__contactUsFormInner",
  "form": "ContactUsForm-module-scss-module__P1OLdq__form",
  "formAgreement": "ContactUsForm-module-scss-module__P1OLdq__formAgreement",
  "sectionSubtitle": "ContactUsForm-module-scss-module__P1OLdq__sectionSubtitle",
  "sectionTitle": "ContactUsForm-module-scss-module__P1OLdq__sectionTitle",
  "socials": "ContactUsForm-module-scss-module__P1OLdq__socials",
  "tel": "ContactUsForm-module-scss-module__P1OLdq__tel",
});
